import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { getDeclarationSetupTableColumns } from '../utils/declarationSetupTableColumns';
import { DeclarationTableWrapper, StyledButton } from '../styled';
import { SchoolDeclarationType } from '../types';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface DeclarationSetupTableAndActionsProps {
  declarationSetupData: SchoolDeclarationType[];
  onEdit: (rowDeclarationData: SchoolDeclarationType) => void;
  onDelete: (rowDeclarationData: SchoolDeclarationType) => void;
  onAddDeclarationForGrade: (value: boolean) => void;
}

const DeclarationSetupTable: React.FC<DeclarationSetupTableAndActionsProps> = ({
  declarationSetupData,
  onEdit,
  onDelete,
  onAddDeclarationForGrade
}) => {
  const columns = getDeclarationSetupTableColumns(onEdit, onDelete);

  return (
    <DeclarationTableWrapper>
      <StyledButton onClick={() => onAddDeclarationForGrade(true)}>
        Add
      </StyledButton>
      <DataGrid
        rowHeight={50}
        rows={declarationSetupData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </DeclarationTableWrapper>
  );
};

export default DeclarationSetupTable;
